module.exports = __webpack_public_path__ + "img/ZJ5279.fd82bdca.png";